
export default {
  // Grey background (image in bottom)
  name: 'DsRepresentativeSeven',
  props: {
    image: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
}
